/// <reference types="vite/client" />
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { Druckrahmen } from './Druck'
import { Stoerungsfenster, Wartehinweis } from './Stoerungsfenster'
import { Erfolgskaestchen } from './Erfolgskaestchen'
import { beobachteKnoepfe } from './Stoerungsstelle'
import './stil.css'

// Der gedrückte Knopf zeigt, dass gearbeitet wird (7.2 Abschnitt 40, R1250).
beobachteKnoepfe()

const wurzel = document.getElementById('wurzel')
if (!wurzel) {
  throw new Error('Der Einhängepunkt "wurzel" fehlt in index.html.')
}

/*
  **Der Druckrahmen liegt um die ganze Anwendung** (7.2 Abschnitt 19, R810).

  Nicht um einen Bildschirm: Was beim Drucken gilt, gilt für jeden -- auch
  für die, die es noch nicht gibt. Hier steht er, weil er einen Seitenfuß
  anhängt und vor dem Druck aufklappt; das Aussehen steht im Gestaltungsblatt.
*/
/*
  **Das Störungsfenster und der Wartehinweis liegen ebenso um alles** (7.2
  Abschnitt 30, R1003, R1005) — auch um die Anmeldung, die vor der
  eigentlichen Anwendung steht. Daneben das Kästchen für das, was gelang
  (7.2 Abschnitt 34, R1130).
*/
createRoot(wurzel).render(
  <StrictMode>
    <Druckrahmen>
      <App />
    </Druckrahmen>
    <Stoerungsfenster />
    <Wartehinweis />
    <Erfolgskaestchen />
  </StrictMode>,
)

/*
  **Der Wächter gegen rohe Codes, nur in der Entwicklungsfassung** (7.2
  Abschnitt 38, R1221). Nachgeladen statt eingebunden: In der ausgelieferten
  Fassung steht hier `false`, und der Wächter kommt gar nicht erst mit.
*/
if (import.meta.env.DEV) {
  void import('./Codewaechter').then((w) => w.starteWaechter())
}
